module.exports = __webpack_public_path__ + "static/media/Aesherah-sm.31d7197c.jpg";